interface MenuItem {
  name: string;
  icon: string;
  route?: string; 
  //  for dropdown headers
  roles: string[]; 
  // AucdtAdminType 
  children?: MenuItem[];
}

const SIDEBAR_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    icon: 'dashboard',
    route: '/dashboard',
    roles: ['SYSADMIN', 'MANAGEMENT', 'REGISTRAR', 'ADMIN', 'HOD', 'LECTURER', 'EXAM_OFFICER', 'ACCOUNTANT', 'QA', 'DEAN', 'LIBRARIAN', 'ESTMANAGER', 'FOUNDER'] // all Asantes
  },

  // ACADEMIC MANAGEMENT
  {
    name: 'Academic Management',
    icon: 'school',
    roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'REGISTRAR', 'ADMIN'],
    children: [
      {
        name: 'Academic Calendar',
        icon: 'event',
        route: '/academic-calendar',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'REGISTRAR', 'ADMIN']
      },
      {
        name: 'Academic Sessions',
        icon: 'schedule',
        route: '/academic-sessions',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'REGISTRAR']
      },
      {
        name: 'Semester Management',
        icon: 'date_range',
        route: '/semesters',
        roles: ['SYSADMIN', 'MANAGEMENT', 'VICE_CHANCELLOR', 'DEAN', 'REGISTRAR']
      },
      {
        name: 'Academic Policies',
        icon: 'policy',
        route: '/academic-policies',
        roles: ['SYSADMIN', 'MANAGEMENT', 'VICE_CHANCELLOR', 'DEAN']
      },
      {
        name: 'Curriculum Management',
        icon: 'menu_book',
        route: '/curriculum',
        roles: ['SYSADMIN', 'MANAGEMENT', 'VICE_CHANCELLOR', 'DEAN', 'HOD']
      }
    ]
  },

  // STUDENT MANAGEMENT
  {
    name: 'Student Management',
    icon: 'groups',
    roles: ['SYSADMIN', 'MANAGEMENT', 'REGISTRAR', 'ADMIN', 'HOD', 'DEAN'],
    children: [
      {
        name: 'Student Registration',
        icon: 'person_add',
        route: '/student-registration',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN']
      },
      {
        name: 'Student Records',
        icon: 'folder_shared',
        route: '/student-records',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'HOD']
      },
      {
        name: 'Student Profile',
        icon: 'account_circle',
        route: '/student-profiles',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'HOD', 'LECTURER']
      },
      {
        name: 'Class Lists',
        icon: 'format_list_numbered',
        route: '/class-lists',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD', 'LECTURER']
      },
      {
        name: 'Student Analytics',
        icon: 'analytics',
        route: '/student-analytics',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'VICE_CHANCELLOR']
      },
      {
        name: 'Disciplinary Records',
        icon: 'gavel',
        route: '/disciplinary-records',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'VICE_CHANCELLOR']
      }
    ]
  },

  // APPLICANT MANAGEMENT 
  {
    name: 'Applicant Management',
    icon: 'group_add',
    roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT', 'DEAN'],
    children: [

      {
        name: 'Registrar Dashboard',
        icon: 'supervised_user_circle',
        route: '/dashboard/registrar-dashboard',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT']
      },

        {
        name: 'New Signps',
        icon: 'supervised_user_circle',
        route: '/dashboard/new-applications',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT']
      },
      {
        name: 'Semester Applicants',
        icon: 'supervised_user_circle',
        route: '/dashboard/semester-applicants',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT']
      },
      {
        name: 'Application Review',
        icon: 'rate_review',
        route: '/dashboard/application-review',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT', 'DEAN']
      },

      {
          name: 'Applicant-Old TB',
        icon: 'rate_review',
        route: '/dashboard/applicants-from-old-app',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT', 'DEAN']
      
      },
      {
        name: 'Accepted Applicants',
        icon: 'assignment_ind',
        route: '/accepted-applicants',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN', 'MANAGEMENT']
      },
      {
        name: 'Registered Applicants',
        icon: 'verified',
        route: '/registered-applicants',
        roles: ['SYSADMIN', 'REGISTRAR', 'ADMIN']
      },
      {
        name: 'Admission Statistics',
        icon: 'bar_chart',
        route: '/admission-stats',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Assign Reviewers',
        icon: 'add_task',
        route: '/assign-reviewer',
        roles: ['SYSADMIN', 'ADMIN', 'QA']
      },
    ]
  },

  // FACULTY & STAFF MANAGEMENT
  {
    name: 'Faculty & Staff',
    icon: 'badge',
    roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'ADMIN'],
    children: [
      {
        name: 'Staff Directory',
        icon: 'contact_phone',
        route: '/staff-directory',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'ADMIN']
      },
      {
        name: 'Faculty Management',
        icon: 'engineering',
        route: '/faculty-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Staff Records',
        icon: 'assignment_ind',
        route: '/staff-records',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN']
      },
      {
        name: 'Performance Reviews',
        icon: 'star_rate',
        route: '/performance-reviews',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD']
      },
      {
        name: 'Leave Management',
        icon: 'event_available',
        route: '/leave-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'HOD', 'ADMIN']
      },
      {
        name: 'Workload Distribution',
        icon: 'work',
        route: '/workload-distribution',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD']
      }
    ]
  },

  // COURSE & CURRICULUM MANAGEMENT
  {
    name: 'Courses & Programs',
    icon: 'library_books',
    roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'LECTURER', 'REGISTRAR'],
    children: [
      {
        name: 'Course Catalog',
        icon: 'menu_book',
        route: '/course-catalog',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'LECTURER', 'REGISTRAR']
      },
      {
        name: 'Program Management',
        icon: 'school',
        route: '/program-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD']
      },
      {
        name: 'Course Scheduling',
        icon: 'schedule',
        route: '/course-scheduling',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD', 'DEAN']
      },
      {
        name: 'Prerequisites',
        icon: 'account_tree',
        route: '/prerequisites',
        roles: ['SYSADMIN', 'DEAN', 'HOD', 'REGISTRAR']
      },
      {
        name: 'Course Enrollment',
        icon: 'how_to_reg',
        route: '/course-enrollment',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD', 'LECTURER']
      },
      {
        name: 'Syllabus Management',
        icon: 'description',
        route: '/syllabus-management',
        roles: ['SYSADMIN', 'DEAN', 'HOD', 'LECTURER']
      }
    ]
  },

  // EXAMINATION & GRADING
  {
    name: 'Examinations',
    icon: 'quiz',
    roles: ['SYSADMIN', 'EXAM_OFFICER', 'LECTURER', 'HOD', 'DEAN', 'REGISTRAR'],
    children: [
      {
        name: 'Exam Scheduling',
        icon: 'event_note',
        route: '/exam-scheduling',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'REGISTRAR', 'HOD']
      },
      {
        name: 'Grade Management',
        icon: 'grade',
        route: '/grade-management',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'LECTURER', 'HOD']
      },
      {
        name: 'Transcripts',
        icon: 'description',
        route: '/transcripts',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'REGISTRAR']
      },
      {
        name: 'Results Processing',
        icon: 'fact_check',
        route: '/results-processing',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'LECTURER']
      },
      {
        name: 'Exam Analytics',
        icon: 'trending_up',
        route: '/exam-analytics',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'HOD', 'DEAN']
      },
      {
        name: 'Academic Probation',
        icon: 'warning',
        route: '/academic-probation',
        roles: ['SYSADMIN', 'EXAM_OFFICER', 'DEAN', 'REGISTRAR']
      }
    ]
  },

  // FINANCIAL MANAGEMENT
  {
    name: 'Financial Management',
    icon: 'account_balance',
    roles: ['SYSADMIN', 'ACCOUNTANT', 'MANAGEMENT'],
    children: [

      {
        name: 'Finance Dashboard',
        icon: 'grid_view',
        route: '/dashboard/accountant-dashboard', 
        roles: ['SYSADMIN', 'QA', 'ACCOUNTANT', 'MANAGEMENT']
      },

    {
        name: 'Applications fees',
        icon: 'payments',
        route: '/dashboard/application-fees',
        roles: ['SYSADMIN', 'ACCOUNTANT']
      },
      {
        name: 'Fee Management',
        icon: 'payments',
        route: '/fee-management',
        roles: ['SYSADMIN', 'ACCOUNTANT']
      },
      {
        name: 'Add Fee Items',
        icon: 'add_circle',
        route: '/dashboard/add-fees-items',
        roles: ['SYSADMIN', 'ACCOUNTANT']
      },
      {
        name: 'Student Accounts',
        icon: 'account_balance_wallet',
        route: '/student-accounts',
        roles: ['SYSADMIN', 'ACCOUNTANT']
      },
      {
        name: 'Scholarships',
        icon: 'school',
        route: '/scholarships',
        roles: ['SYSADMIN', 'ACCOUNTANT', 'BURSAR', 'MANAGEMENT']
      },
      {
        name: 'Budget Management',
        icon: 'pie_chart',
        route: '/budget-management',
        roles: ['SYSADMIN', 'ACCOUNTANT', 'BURSAR', 'MANAGEMENT']
      },
      {
        name: 'Financial Reports',
        icon: 'assessment',
        route: '/financial-reports',
        roles: ['SYSADMIN', 'ACCOUNTANT', 'BURSAR', 'MANAGEMENT']
      },
      {
        name: 'Payroll Management',
        icon: 'attach_money',
        route: '/payroll',
        roles: ['SYSADMIN', 'ACCOUNTANT']
      }
    ]
  },

  // ATTENDANCE & CLASSROOM
  {
    name: 'Attendance & Classroom',
    icon: 'fact_check',
    roles: ['SYSADMIN', 'LECTURER', 'HOD', 'REGISTRAR'],
    children: [
      {
        name: 'Class Attendance',
        icon: 'how_to_reg',
        route: '/class-attendance',
        roles: ['SYSADMIN', 'LECTURER', 'HOD']
      },
      {
        name: 'Roll Call',
        icon: 'format_list_numbered',
        route: '/roll-call',
        roles: ['SYSADMIN', 'LECTURER']
      },
      {
        name: 'Attendance Reports',
        icon: 'summarize',
        route: '/attendance-reports',
        roles: ['SYSADMIN', 'LECTURER', 'HOD', 'REGISTRAR']
      },
      {
        name: 'Classroom Management',
        icon: 'meeting_room',
        route: '/classroom-management',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD']
      },
      {
        name: 'Facial Recognition',
        icon: 'face',
        route: '/facial-recognition',
        roles: ['SYSADMIN', 'HOD']
      },
      {
        name: 'Lecture Schedules',
        icon: 'schedule',
        route: '/lecture-schedules',
        roles: ['SYSADMIN', 'LECTURER', 'HOD', 'REGISTRAR']
      }
    ]
  },

  // LIBRARY MANAGEMENT
  {
    name: 'Library Services',
    icon: 'local_library',
    roles: ['SYSADMIN', 'LIBRARIAN', 'MANAGEMENT', 'LECTURER'],
    children: [
      {
        name: 'Library Catalog',
        icon: 'import_contacts',
        route: '/library-catalog',
        roles: ['SYSADMIN', 'LIBRARIAN', 'MANAGEMENT', 'LECTURER']
      },
      {
        name: 'Book Management',
        icon: 'library_books',
        route: '/book-management',
        roles: ['SYSADMIN', 'LIBRARIAN']
      },
      {
        name: 'Digital Resources',
        icon: 'cloud_download',
        route: '/digital-resources',
        roles: ['SYSADMIN', 'LIBRARIAN', 'LECTURER']
      },
      {
        name: 'Library Analytics',
        icon: 'bar_chart',
        route: '/library-analytics',
        roles: ['SYSADMIN', 'LIBRARIAN', 'MANAGEMENT']
      },
      {
        name: 'Research Support',
        icon: 'research',
        route: '/research-support',
        roles: ['SYSADMIN', 'LIBRARIAN', 'LECTURER']
      }
    ]
  },

  // RESEARCH & PUBLICATIONS
  {
    name: 'Research & Publications',
    icon: 'science',
    roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'LECTURER'],
    children: [
      {
        name: 'Research Projects',
        icon: 'assignment',
        route: '/research-projects',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'LECTURER']
      },
      {
        name: 'Grant Management',
        icon: 'monetization_on',
        route: '/grant-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Publications',
        icon: 'article',
        route: '/publications',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'LECTURER']
      },
      {
        name: 'Ethics Committee',
        icon: 'verified_user',
        route: '/ethics-committee',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Research Analytics',
        icon: 'timeline',
        route: '/research-analytics',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN']
      }
    ]
  },

  // FACILITIES & INFRASTRUCTURE
  {
    name: 'Facilities Management',
    icon: 'domain',
    roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN', 'ESTMANAGER'],
    children: [
      {
        name: 'Room Booking',
        icon: 'event_seat',
        route: '/room-booking',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN', 'LECTURER']
      },
      {
        name: 'Maintenance Requests',
        icon: 'build',
        route: '/maintenance-requests',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN']
      },
      {
        name: 'Asset Management',
        icon: 'inventory',
        route: '/asset-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN']
      },
      {
        name: 'Hostel Management',
        icon: 'hotel',
        route: '/hostel-management',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN']
      },
      {
        name: 'Transport Services',
        icon: 'directions_bus',
        route: '/transport-services',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ADMIN']
      }
    ]
  },

  // QUALITY ASSURANCE
  {
    name: 'Quality Assurance',
    icon: 'verified',
    roles: ['SYSADMIN', 'QA', 'MANAGEMENT', 'DEAN'],
    children: [
      // --- NEW QA DASHBOARD LINK ---
      {
        name: 'QA Dashboard',
        icon: 'grid_view',
        route: '/dashboard/qa-dashboard', // Maps to child route in app-routing.module.ts
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT', 'DEAN']
      },
      // -----------------------------
      {
        name: 'Course Evaluations',
        icon: 'rate_review',
        route: '/course-evaluations',
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Faculty Evaluations',
        icon: 'star_rate',
        route: '/faculty-evaluations',
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Accreditation',
        icon: 'workspace_premium',
        route: '/accreditation',
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT']
      },
      {
        name: 'Quality Reports',
        icon: 'assessment',
        route: '/quality-reports',
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT', 'DEAN']
      },
      {
        name: 'Improvement Plans',
        icon: 'trending_up',
        route: '/improvement-plans',
        roles: ['SYSADMIN', 'QA', 'MANAGEMENT']
      }
    ]
  },

  // COMMUNICATIONS
  {
    name: 'Communications',
    icon: 'forum',
    roles: ['SYSADMIN', 'ADMIN', 'MANAGEMENT', 'HOD', 'LECTURER'],
    children: [
      {
        name: 'Announcements',
        icon: 'campaign',
        route: '/announcements',
        roles: ['SYSADMIN', 'ADMIN', 'MANAGEMENT', 'HOD']
      },
      {
        name: 'Mailbox',
        icon: 'attach_email',
        route: '/email',
        roles: ['SYSADMIN', 'ADMIN']
      },
      {
        name: 'Notifications',
        icon: 'notifications',
        route: '/notifications',
        roles: ['SYSADMIN', 'ADMIN', 'MANAGEMENT']
      },
      {
        name: 'Forums',
        icon: 'forum',
        route: '/forums',
        roles: ['SYSADMIN', 'LECTURER']
      },
      {
        name: 'Comments',
        icon: 'comment',
        route: '/comments',
        roles: ['SYSADMIN', 'ADMIN', 'QA']
      },
      {
        name: 'Feedback System',
        icon: 'feedback',
        route: '/feedback-system',
        roles: ['SYSADMIN', 'ADMIN', 'QA', 'MANAGEMENT']
      }
    ]
  },

  // CTVET MODULE (Enhanced)
  {
    name: 'CTVET Module',
    icon: 'school',
    roles: ['SYSADMIN', 'REGISTRAR', 'HOD', 'LECTURER'],
    children: [
      {
        name: 'CTVET Dashboard',
        icon: 'manage_accounts',
        route: '/ctvet-dashboard',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD']
      },
      {
        name: 'CTVET Attendance',
        icon: 'how_to_reg',
        route: '/ctvet-attendance',
        roles: ['SYSADMIN', 'HOD', 'LECTURER']
      },
      {
        name: 'Skills Assessment',
        icon: 'engineering',
        route: '/skills-assessment',
        roles: ['SYSADMIN', 'HOD', 'LECTURER']
      },
      {
        name: 'Competency Tracking',
        icon: 'emoji_events',
        route: '/competency-tracking',
        roles: ['SYSADMIN', 'HOD', 'LECTURER']
      },
      {
        name: 'Industry Partnerships',
        icon: 'handshake',
        route: '/industry-partnerships',
        roles: ['SYSADMIN', 'HOD', 'MANAGEMENT']
      },
      {
        name: 'Register CTVET Student',
        icon: 'app_registration',
        route: '/register-ctvet-student',
        roles: ['SYSADMIN', 'REGISTRAR', 'HOD']
      },
    ]
  },

  // REPORTS & ANALYTICS
  {
    name: 'Reports & Analytics',
    icon: 'analytics',
    roles: ['SYSADMIN', 'MANAGEMENT', 'ACCOUNTANT', 'DEAN', 'HOD'],
    children: [
      {
        name: 'Executive Dashboard',
        icon: 'dashboard',
        route: '/executive-dashboard',
        roles: ['SYSADMIN', 'MANAGEMENT']
      },
      {
        name: 'Academic Reports',
        icon: 'school',
        route: '/academic-reports',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD', 'REGISTRAR']
      },
      {
        name: 'Financial Reports',
        icon: 'attach_money',
        route: '/financial-reports-detailed',
        roles: ['SYSADMIN', 'MANAGEMENT', 'ACCOUNTANT']
      },
      {
        name: 'Student Analytics',
        icon: 'people',
        route: '/student-analytics-detailed',
        roles: ['SYSADMIN', 'MANAGEMENT', 'DEAN', 'HOD']
      },
      {
        name: 'Performance Metrics',
        icon: 'trending_up',
        route: '/performance-metrics',
        roles: ['SYSADMIN', 'MANAGEMENT', 'VICE_CHANCELLOR', 'DEAN']
      },
      {
        name: 'Custom Reports',
        icon: 'assessment',
        route: '/custom-reports',
        roles: ['SYSADMIN', 'MANAGEMENT']
      }
    ]
  },

  // SYSTEM ADMINISTRATION
  {
    name: 'System Administration',
    icon: 'settings',
    roles: ['SYSADMIN', 'ADMIN'],
    children: [
      // --- NEW SYSADMIN DASHBOARD LINK ---
      {
        name: 'SysAdmin Dashboard',
        icon: 'monitor',
        route: '/dashboard/sysadmin-dashboard', 
        roles: ['SYSADMIN']
      },
      // ------------------------------------
      {
        name: 'User Management',
        icon: 'supervised_user_circle',
        route: '/dashboard/user-management',
        roles: ['SYSADMIN', 'ADMIN']
      },
      {
        name: 'User Sign Ups',
        icon: 'person_add',
        route: '/dashboard/user-accounts',
        roles: ['SYSADMIN', 'ADMIN']
      },
      {
        name: 'Role Management',
        icon: 'admin_panel_settings',
        route: '/dashboard/role-management',
        roles: ['SYSADMIN']
      },
      {
        name: 'System Configuration',
        icon: 'settings_applications',
        route: '/system-config',
        roles: ['SYSADMIN']
      },
      {
        name: 'Backup & Recovery',
        icon: 'backup',
        route: '/backup-recovery',
        roles: ['SYSADMIN']
      },
      {
        name: 'Audit Logs',
        icon: 'history',
        route: '/audit-logs',
        roles: ['SYSADMIN']
      },
      {
        name: 'Security Settings',
        icon: 'security',
        route: '/security-settings',
        roles: ['SYSADMIN']
      }
    ]
  }
];

export { MenuItem, SIDEBAR_MENU };
